const SERVICE_COMING_SOON_PAGES = [
    // {
    //     slug: 'storage-vps',
    //     label: 'Storage VPS',
    //     description: 'High-capacity storage VPS plans from Trivox are coming soon. Scalable block storage with EU hosting in Amsterdam.',
    //     intro: 'Storage VPS plans with flexible capacity and EU hosting are on the way. Explore our virtual and dedicated servers while we finish the launch.',
    //     primaryLink: { to: '/services/vps-kvm', label: 'Virtual Servers' },
    //     secondaryLink: { to: '/services/dedicated-servers', label: 'Dedicated Servers' },
    // },
];

export default SERVICE_COMING_SOON_PAGES;
